import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormArray, FormBuilder} from '@angular/forms';
import {MarketingService} from '../../../../../shared/_services/marketing.service';
import {UtilService} from '../../../../../shared/_services/util.service';
import {HcaUserManagementService} from '../../../../../shared/_services/hca-user-management.service';
import {StatusModalComponent} from '../../../../modals/status-modal/status-modal.component';
import {BsModalService, BsModalRef} from 'ngx-bootstrap';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss']
})
export class PromotionsComponent implements OnInit {
  isInit: any;
  hotels: any;
  promoRulesList: any;
  searchText: string;
  searchForm: FormGroup;
  statusModal: BsModalRef;
  promoList: any[] = [];
  selectedPromos: any[] = [];
  filterDefault = true;
  allPromosSelected = false;
  actionSvg = 'assets/images/action-inactive.svg';
  promotionsForm: FormGroup;

  bsModalRef: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private hcaUserManagementService: HcaUserManagementService,
    private marketingService: MarketingService,
    private modalService: BsModalService,
    private utilService: UtilService
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(() => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action === 'action1') {
          if (this.statusModal.content.srcObject.type === 'promo-list') {
            if (this.statusModal.content.srcObject.status) {
              let statusId: any;
              let status: string;
              if (this.statusModal.content.srcObject.status === 'Activate') {
                statusId = 1;
                status = 'Active';
              } else {
                statusId = 0;
                status = 'Inactive';
              }

              this.marketingService.activateOrDeactivatePromos(this.statusModal.content.srcObject.id, statusId).subscribe(
                () => {
                  if (this.statusModal.content.srcObject.form === '') {
                    this.getPromotionData(this.promotionsForm.value);
                  } else {
                    this.statusModal.content.srcObject.form.status = status;
                  }
                }, error => {
                  console.error(error);
                });
            }
          }
        }
      }
    });
  }

  offClickHandler(event: any) {
    if (!event.target.closest('.filter') && !event.target.closest('.filter')) {
      if (document.getElementById('ul')) {
        document.getElementById('ul').style.display = 'none';
      }
    }
  }

  dropDown() {
    if (document.getElementById('ul').style.display === 'block') {
      document.getElementById('ul').style.display = 'none';
    } else {
      document.getElementById('ul').style.display = 'block';
    }
  }

  getPromotionRules(isInit?) {
    this.marketingService.getPromotionRules().subscribe(res => {
      if (res.error === 0) {
        this.promoRulesList = res.responseObj;
        this.isInit = isInit;
        this.checkSelection(true, 'promotionsForm', 'brandIds', 0);
        this.getHotelsList();
        // this.selectAll('brand', 'promotionsForm');
      }
    });
  }

  getPromotionData(data) {
    this.marketingService.getPromotionData(data).subscribe(res => {
      if (res.error === 0) {
        if (res.responseObj) {
          this.promoList = res.responseObj;
          this.allPromosSelected = false;
          this.selectedPromos = [];
        }
      }
    });
  }

  getHotelsList() {
    const brandIds = this.utilService.cleanArray(this.promotionsForm.get('brandIds').value);
    this.hcaUserManagementService.getHotelsByBrand(brandIds).subscribe(
      res => {
        if (res.error === 0) {
          if (res.responseObj) {
            this.hotels = res.responseObj;
            this.checkSelection(true, 'promotionsForm', 'hotelIds', 0);
          }
        } else {
          this.hotels = [];
          this.checkSelection(false, 'promotionsForm', 'hotelIds', 0);
          console.error('Get Hotels : ' + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  checkSelection(isChecked?: boolean, control?, type?, id?) {
    const formControl = <FormArray>this[control].controls[type];
    const arrayType = type === 'hotelIds' ? this.hotels : this.promoRulesList.brands;
    if (isChecked) {
      if (id === 0) {
        while (formControl.value.length !== 0) {
          formControl.removeAt(0);
        }
        formControl.push(new FormControl(0));
        arrayType.forEach(value => {
          formControl.push(new FormControl(type === 'hotelIds' ? value.hotelId : value.brandId));
        });
      } else {
        formControl.push(new FormControl(id));
        if (formControl.value.indexOf(0) === -1 && arrayType.length === formControl.value.length) {
          formControl.push(new FormControl(0));
        }
      }
    } else {
      if (id === 0) {
        while (formControl.value.length !== 0) {
          formControl.removeAt(0);
        }
      } else {
        const index = formControl.controls.findIndex(x => x.value === id);
        if (index > -1) {
          formControl.removeAt(index);
        }
        if (formControl.value.indexOf(0) > -1) {
          if (arrayType.length !== formControl.value.length - 1) {
            const idx = formControl.controls.findIndex(x => x.value === 0);
            if (idx > -1) {
              formControl.removeAt(idx);
            }
          }
        }
      }
    }
  }

  checkPromoSelection(type) {
    if (type === 'promo') {
      this.allPromosSelected = this.promoList.every(function (item: any) {
        return item.checked === true;
      });
      this.selectedPromos = this.utilService.cleanArray(this.promoList.map(promo => {
        if (promo.checked) {
          this.actionSvg = 'assets/images/action-active.svg';
          return promo.promocodeId;
        } else if (this.selectedPromos.length > 0) {
          this.actionSvg = 'assets/images/action-active.svg';
        }
      }));
    }
  }

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  selectAll(type) {
    if (type === 'promo') {
      for (let i = 0; i < this.promoList.length; i++) {
        this.promoList[i].checked = this.allPromosSelected;
      }
      this.selectedPromos = this.utilService.cleanArray(this.promoList.map(promo => {
        if (promo.checked) {
          this.actionSvg = 'assets/images/action-active.svg';
          return promo.promocodeId;

        } else {
          this.actionSvg = 'assets/images/action-inactive.svg';
        }

      }));
    }
  }

  SelectAllPromos(type) {
    if (type === 'Active') {
      this.openModalActivateDeactivate(this.selectedPromos, 'Active', '');
    } else if (type === 'Inactive') {
      this.openModalActivateDeactivate(this.selectedPromos, 'Inactive', '');
    }
  }

  openModalActivateDeactivate(id, mode, promo) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    let message = '';
    let title = '';
    let action1 = '';
    let style = '';
    let status = '';
    if (mode === 'Active') {
      message = 'Are you sure you want to deactivate Promo(s)?';
      title = 'Deactivate Promo';
      action1 = 'Deactivate';
      style = 'inactive';
      status = 'Inactive';
    } else if (mode === 'Inactive') {
      message = 'Are you sure you want to activate Promo(s)?';
      title = 'Activate Promo';
      action1 = 'Activate';
      style = 'active';
      status = 'Activate';
    }
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'promo-list',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style,
      form: promo
    };
  }

  pageChanged() {
    const data = this.promotionsForm.value;
    data.searchTerm = this.searchForm.value.searchTerm;
    this.getPromotionData(data);
  }

  initForm() {
    this.promotionsForm = new FormGroup({
      isActive: new FormControl(''),
      promoCodeTypeId: new FormControl(''),
      transactionTypeId: new FormControl(''),
      brandIds: new FormArray([]),
      hotelIds: new FormArray([])
    });
    this.promotionsForm.controls['brandIds'].valueChanges.debounceTime(400).subscribe(() => {
      this.getHotelsList();
    }, err => {
      console.error('Error while fetching getRewardsList data: ', err);
    });

    this.promotionsForm.valueChanges.debounceTime(600).subscribe(() => {
      if (this.isInit) {
        this.pageChanged();
        this.isInit = false;
        this.filterDefault = true;
      } else {
        this.filterDefault = false;
        this.pageChanged();
      }
    });
  }

  initSearchForm() {
    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
    this.searchForm.get('searchTerm').valueChanges.debounceTime(400).distinctUntilChanged()
      .subscribe(() => {
        this.pageChanged();
      });
  }


  ngOnInit() {
    this.initForm();
    this.initSearchForm();
    this.isInit = true;
    this.getPromotionRules(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/marketing/promotions/promotions.component.ts